import React, { useEffect, useState } from 'react';
import './SelectBox.css'; 


const SelectBoxSmall = ({ label, options = [], defaultValue='', border='', onChange, className='', error }) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() =>{
      setValue(defaultValue)
    },[defaultValue])

  const handleChange = (event) => {
    setValue(event.target.value);
    if (onChange) onChange(event);
  };


  const displayErrors = [error] 

  return (
    <div className={`small-select-box-container ${className}`}>
      <select className={`select-box color-999 fts-15 common-text ftw-4 ${border}`} value={value} onChange={handleChange} >
        <option value="" disabled hidden>  </option>
        {options.map((option, index) => (
          <option className='fts-15 common-text fts-15 ftw-4' key={index} value={option.value}>{option.label}</option>
        ))}
      </select>
      <label className={`select-label fts-15 common-text ftw-4 color-999 ${value ? 'has-value' : ''}`}>{label}</label>
      <div className="select-box-icon">
        <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6L0.535899 0L7.4641 0L4 6Z" fill="#424242"/>
        </svg>
      </div>
      {displayErrors.length > 0 && (
        <div className="input-error-message fts-12">
          {displayErrors[0]}
        </div>
      )}
    </div>
   
  );
};

export default SelectBoxSmall;